var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cus-dialog",
    {
      attrs: {
        title: _vm.$tran("Change Password"),
        visible: _vm.passwordVisitable,
        close: _vm.closeDialog,
        showClose: false,
      },
    },
    [
      _c("div", { staticClass: "updateDialog-content" }, [
        _c(
          "div",
          {
            staticClass: "base-flex relative",
            staticStyle: { width: "0px", height: "0px", overflow: "hidden" },
          },
          [
            _c("cus-input", {
              staticClass: "base-flex-grow1",
              attrs: {
                placeholder: _vm.$tran("Enter the original password"),
                size: "big",
                password: "",
                type: _vm.oldpasswordVisable ? "password" : "text",
                autocomplete: "new-password",
                autocomplete: "new-password",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "base-flex relative" },
          [
            _c("span", { staticClass: "base-bText14" }, [
              _vm._v(_vm._s(_vm.$tran("Old Password"))),
            ]),
            _c(
              "cus-input",
              {
                staticClass: "base-flex-grow1",
                attrs: {
                  placeholder: _vm.$tran("Enter the original password"),
                  size: "big",
                  password: "",
                  type: _vm.oldpasswordVisable ? "password" : "text",
                  autocomplete: "new-password",
                  autocomplete: "new-password",
                },
                model: {
                  value: _vm.passwordObj.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.passwordObj, "password", $$v)
                  },
                  expression: "passwordObj.password",
                },
              },
              [
                _c("i", {
                  class: _vm.oldpasswordVisable
                    ? "el-icon-lock"
                    : "el-icon-unlock",
                  attrs: { slot: "suffix" },
                  on: {
                    click: function ($event) {
                      _vm.oldpasswordVisable = !_vm.oldpasswordVisable
                    },
                  },
                  slot: "suffix",
                }),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "base-flex relative",
            staticStyle: { "margin-top": "30px" },
          },
          [
            _c("span", { staticClass: "base-bText14" }, [
              _vm._v(_vm._s(_vm.$tran("New Password"))),
            ]),
            _c(
              "cus-input",
              {
                staticClass: "base-flex-grow1",
                attrs: {
                  placeholder: _vm.$tran("Enter a new password"),
                  size: "big",
                  password: "",
                  type: _vm.passwordDisplay ? "password" : "text",
                },
                model: {
                  value: _vm.passwordObj.newPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.passwordObj, "newPassword", $$v)
                  },
                  expression: "passwordObj.newPassword",
                },
              },
              [
                _c("i", {
                  class: _vm.passwordDisplay
                    ? "el-icon-lock"
                    : "el-icon-unlock",
                  attrs: { slot: "suffix" },
                  on: {
                    click: function ($event) {
                      _vm.passwordDisplay = !_vm.passwordDisplay
                    },
                  },
                  slot: "suffix",
                }),
              ]
            ),
            _c("div", { staticClass: "resetpassword-tip" }, [
              _vm._v(
                _vm._s(
                  _vm.$tran(
                    "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters"
                  )
                )
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "base-flex relative" },
          [
            _c("span", { staticClass: "base-bText14" }, [
              _vm._v(_vm._s(_vm.$tran("Confirm Password"))),
            ]),
            _c(
              "cus-input",
              {
                staticClass: "base-flex-grow1",
                attrs: {
                  placeholder: _vm.$tran("Enter the new password again"),
                  size: "big",
                  password: "",
                  type: _vm.passwordDisplay2 ? "password" : "text",
                },
                model: {
                  value: _vm.passwordObj.newConfirmPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.passwordObj, "newConfirmPassword", $$v)
                  },
                  expression: "passwordObj.newConfirmPassword",
                },
              },
              [
                _c("i", {
                  class: _vm.passwordDisplay2
                    ? "el-icon-lock"
                    : "el-icon-unlock",
                  attrs: { slot: "suffix" },
                  on: {
                    click: function ($event) {
                      _vm.passwordDisplay2 = !_vm.passwordDisplay2
                    },
                  },
                  slot: "suffix",
                }),
              ]
            ),
            _c("div", { staticClass: "resetpassword-tip" }, [
              _vm._v(
                _vm._s(_vm.$tran("This must match the new password above"))
              ),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "updateDialog-footer" },
        [
          _c(
            "cus-button",
            { attrs: { type: "confirm" }, on: { click: _vm.gotoLogin } },
            [_vm._v(_vm._s(_vm.$tran("Cancel")))]
          ),
          _c(
            "cus-button",
            { attrs: { type: "confirm" }, on: { click: _vm.confirmUpdate } },
            [_vm._v(_vm._s(_vm.$tran("Confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }